import { css, StyleSheet } from 'aphrodite';
import { IEventTicket, ILineItem } from '../../models/Api';
import { formatCentsAsDollars } from '../../models/currency';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, spacing, typography } = THEME;

const styles = StyleSheet.create({
	sectionTitle: {
		margin: `0 0 ${spacing.md}px`,
		fontSize: typography.fontSizes.xs,
		textTransform: 'uppercase',
		letterSpacing: 1,
		color: colors.text.light,
	},
	totalAmount: {
		fontSize: 32,
		fontWeight: 700,
		margin: `0 0 ${spacing.md}px`,
	},
	lineItemsContainer: {
		borderBottom: `1px solid ${colors.border.light}`,
		paddingBottom: spacing.sm,
		marginBottom: spacing.sm,
	},
	lineItem: {
		display: 'flex',
		justifyContent: 'space-between',
		fontSize: typography.fontSizes.sm,
		padding: `${spacing.xs}px 0`,
	},
	totalRow: {
		display: 'flex',
		justifyContent: 'space-between',
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
	},
});

export const EventOrderSummary = ({
	lineItems,
	tickets,
	totalAmount,
}: {
	lineItems?: ILineItem[];
	tickets?: IEventTicket[];
	totalAmount: string;
}) => {
	const getTicketPrice = (itemId: string): number | undefined => {
		return tickets?.find(t => t.id === itemId)?.unitPrice;
	};

	return (
		<>
			<h3 className={css(styles.sectionTitle)}>Your Order</h3>
			<p className={css(styles.totalAmount)}>{totalAmount}</p>
			<div className={css(styles.lineItemsContainer)}>
				{lineItems?.map(item => {
					const unitPrice = getTicketPrice(item.itemId);
					return (
						<div key={item.itemId} className={css(styles.lineItem)}>
							<span>
								{item.name} &#215; <strong>{item.quantity}</strong>
							</span>
							{unitPrice !== undefined && <span>${formatCentsAsDollars(unitPrice * item.quantity)}</span>}
						</div>
					);
				})}
			</div>
			<div className={css(styles.totalRow)}>
				<span>Total</span>
				<span>{totalAmount}</span>
			</div>
		</>
	);
};
